<div class="info-box">
  <div>
    <div class="widget-container style2023" style="padding-top: 10px">
      <div><h2 class="sub-header-bar">Calls</h2></div>

      <div class="call-table-wrapper">
        <div *ngIf="isBusy" style="height: 275px; line-height: 275px; text-align: center">
          <i class="fa fa-spinner fa-spin fa-2x"></i>&nbsp;Loading...
        </div>

        <div class="flex grid-gap-10 px-3 pt-3" *ngIf="!isBusy">
          <div class="flex-grow-1">
            <p-dropdown
              [options]="dates"
              appendTo="body"
              placeholder="Select Date"
              class="filter-dropdown ui-dropdown-narrow"
              [(ngModel)]="selectedDate"
              (ngModelChange)="onSelectDate($event)"
            ></p-dropdown>
          </div>

          <div class="flex-grow-1">
            <p-dropdown
              [options]="operators"
              appendTo="body"
              placeholder="Select Operator"
              class="filter-dropdown ui-dropdown-narrow"
              [(ngModel)]="selectedOperator"
              (ngModelChange)="onSelectOperator($event)"
            ></p-dropdown>
          </div>

          <div class="flex-grow-1">
            <p-dropdown
              [options]="reasons"
              appendTo="body"
              placeholder="Select User"
              class="filter-dropdown ui-dropdown-narrow"
              [(ngModel)]="selectedReason"
              (ngModelChange)="onSelectReason($event)"
            ></p-dropdown>
          </div>
        </div>

        <div style="height: 300px; overflow-y: auto; padding: 0 10px">
          <table *ngIf="filteredStats" class="call-table w-100 table-striped">
            <thead style="position: sticky; top: 0">
              <tr>
                <th class="text-left">Direction</th>
                <th class="text-left">Date & Time</th>
                <th class="text-left">Response</th>
                <th class="text-left">Operator</th>
                <th class="text-left">Duration</th>
                <th class="text-left">Reason</th>
                <th class="text-left">Associated Job(s)</th>
                <th>AI Summary</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let call of filteredStats"
                [class]="call.oddeven"
                [class.showAISummaryStart]="call.showAISummaryStart"
                [class.showAISummaryEnd]="call.showAISummaryEnd"
              >
                <ng-container *ngIf="call.summaryRow">
                  <td *ngIf="call.summaryRow" colspan="8">
                    <!--                    AI Summary: In this call operator spoke about blah blah and they all spoke about-->
                    <!--                    a lot of important things regarding some job or some expense or some kind of-->
                    <!--                    thing that the operational team needs to know most likely. And with that said,-->
                    <!--                    you should probably act on this information.-->
                    Transcript not yet available in Dialpad API
                  </td>
                </ng-container>
                <ng-container *ngIf="!call.summaryRow">
                  <td>{{ call.outboundCall ? 'Outbound' : 'Inbound' }}</td>
                  <td>{{ call.created | date : 'EEE dd MMM HH:mm' }}</td>
                  <td>{{ call.statName }}</td>
                  <td>{{ call.operatorName }}</td>
                  <td>{{ call.durationText }}</td>
                  <td>{{ call.disposition }}</td>
                  <td>
                    <div *ngFor="let jobInfo of call.associatedJobInfos">
                      <a href="/app/jobscreen/{{ jobInfo.jobId }}" target="_blank">{{
                        jobInfo.jobNumber
                      }}</a>
                    </div>
                  </td>
                  <td
                    (click)="toggleAISummary(call)"
                    pTooltip="This feature is not yet available in Dialpad"
                    style="cursor: pointer; text-align: center"
                  >
                    View
                    <span *ngIf="!call.summaryShowing"><i class="fa fa-caret-down"></i></span>
                    <span *ngIf="call.summaryShowing"><i class="fa fa-caret-up"></i></span>
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
